import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Moment from 'react-moment';

import CommonTable
  from 'components/elements/tables/common-table/CommonTable';

import './AnonymousMessagesListItem.css';

const AnonymousMessagesListItem = ({
  item,
  index,
  activePaginationPage,
  deleteAnonymousMessage,
  isPro,
}) => {
  const { t } = useTranslation();
  const handleDeleteMessage = useCallback((e) => {
    deleteAnonymousMessage(Number(e.target.id));
  }, []);

  return (
    <CommonTable.Row
      className={
        `anonymous-messages-list-item__component${(index > 2 && !isPro) ? ' blocked' : ''}`
      }
    >
      <CommonTable.Cell className="numeric-column">
        <div className="parameter">{t("#")}</div>
        <div className="value">{activePaginationPage * 30 + index + 1}</div>
      </CommonTable.Cell>

      <CommonTable.Cell className="text-message-column">
        <div className="parameter">{t("Text")}</div>
        <div className="value">{item.message}</div>
      </CommonTable.Cell>

      <CommonTable.Cell className="name-author-column">
        <div className="parameter">{t("Name")}</div>
        <div className="value">
          {item.name ||
            <div className="incognoto-user">
              <div className="icon" />
              <span>{t("Anonymous")}</span>
            </div>
          }
        </div>
      </CommonTable.Cell>

      <CommonTable.Cell className="email-column">
        <div className="parameter">{t("Email")}</div>
        <div className="value">{item.email || ''}</div>
      </CommonTable.Cell>

      <CommonTable.Cell className="added-column">
        <div className="parameter">{t("Date Received")}</div>
        <div className="value">
          <Moment
            fromNow
            date={item.created_at}
          />
        </div>
      </CommonTable.Cell>
      <CommonTable.Cell className="action-column">
        <div className="parameter"></div>
        <div
          className="value delete-button"
          id={item.id}
          onClick={handleDeleteMessage}
        >
          <div className="delete-button-wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22"><path d="M9.998 12.521l2.294-2.281 1.414 1.407-2.293 2.281 2.293 2.281-1.414 1.407-2.294-2.281-2.293 2.281-1.413-1.407 2.293-2.281-2.293-2.281 1.413-1.407 2.293 2.281zM4.999 2.984v-.995c0-1.098.895-1.989 2-1.989h6c1.104 0 2 .891 2 1.989v.995h3c1.105 0 2 .891 2 1.99v1.99a1.994 1.994 0 01-2 1.989h-.08l-.92 10.944a1.994 1.994 0 01-2 1.989h-10c-1.105 0-2-.89-1.997-1.907L2.078 8.953h-.079c-1.106 0-2-.89-2-1.989v-1.99c0-1.099.894-1.99 2-1.99h3zm0 1.99h-3v1.99h16v-1.99h-13zm-.914 3.979l.914 10.944h10l.003-.083.91-10.861H4.085zm8.914-5.969v-.995h-6v.995h6z" /></svg>
          </div>
        </div>
      </CommonTable.Cell>
    </CommonTable.Row>
  );
};

AnonymousMessagesListItem.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  activePaginationPage: PropTypes.number,
  deleteAnonymousMessage: PropTypes.func,
  isPro: PropTypes.bool,
};
AnonymousMessagesListItem.defaultProps = {
  item: null,
  index: 0,
  activePaginationPage: 0,
  deleteAnonymousMessage: null,
  isPro: false,
};

export default AnonymousMessagesListItem;
